import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { StoryblokImageTitleComponent } from '../../app/content/modules/storyblok/components/storyblok-image-title/storyblok-image-title.component';
import { withStoryblokDecorators } from '../_utils/story-helpers';

const meta: Meta<StoryblokImageTitleComponent> = {
  title: 'Storyblok/Image Title',
  component: StoryblokImageTitleComponent,
  decorators: [...withStoryblokDecorators()],
  parameters: {
    docs: {
      description: {
        component: 'Storyblok image title component. Displays a title with optional subtitle, icon, and background image.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<StoryblokImageTitleComponent>;

export const Default: Story = {
  args: {
    title: 'Rødvin',
    _uid: 'sb-img-title-1',
    component: 'image_title',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-image-title')).toBeTruthy();
  },
};

export const WithSubtitle: Story = {
  args: {
    title: 'Bordeaux',
    subtitle: 'Udforsk vine fra Frankrigs mest berømte region',
    _uid: 'sb-img-title-2',
    component: 'image_title',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-image-title')).toBeTruthy();
  },
};

export const WithDescription: Story = {
  args: {
    title: 'Hvidvin',
    description: 'Friske og elegante hvide vine fra hele verden.',
    _uid: 'sb-img-title-3',
    component: 'image_title',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-image-title')).toBeTruthy();
  },
};

export const WithBackgroundImage: Story = {
  args: {
    title: 'Vinsmagning',
    subtitle: 'Book din næste oplevelse',
    background_image: { filename: 'https://a.storyblok.com/f/106593/5459x1241/65f115b636/supervin_hvidorange_highres.png' },
    _uid: 'sb-img-title-4',
    component: 'image_title',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-image-title')).toBeTruthy();
  },
};

export const WithIcon: Story = {
  args: {
    title: 'Økologiske Vine',
    icon: { filename: 'https://a.storyblok.com/f/106593/100x100/f35c5f3002/gron-drue-tegning.jpg' },
    _uid: 'sb-img-title-5',
    component: 'image_title',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-storyblok-image-title')).toBeTruthy();
  },
};
